// Keyboard runs for the grid's inline price editor: Enter = save & next item
// DOWN the same supplier column, Tab = save & next supplier RIGHT along the
// same row. Locked cells (awarded, rejected-only, terminal item, saving) are
// skipped; a run never wraps — null closes the editor.

export interface GridCellRef {
  itemId: number;
  sid: number;
}

export function nextEditableCell<TItem extends { id: number }>(
  items: TItem[],
  suppliers: Array<{ sid: number }>,
  from: GridCellRef,
  dir: 'down' | 'right',
  isEditable: (item: TItem, sid: number) => boolean
): GridCellRef | null {
  const row = items.findIndex((it) => it.id === from.itemId);
  const col = suppliers.findIndex((s) => s.sid === from.sid);
  if (row === -1 || col === -1) return null;
  if (dir === 'down') {
    for (let i = row + 1; i < items.length; i++) {
      if (isEditable(items[i], from.sid)) return { itemId: items[i].id, sid: from.sid };
    }
    return null;
  }
  for (let j = col + 1; j < suppliers.length; j++) {
    if (isEditable(items[row], suppliers[j].sid)) return { itemId: from.itemId, sid: suppliers[j].sid };
  }
  return null;
}
